'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');
mmWidgets.fn.accountInvitationWidget = function (subscriptionModel) {
	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			listContainer = element.find('[data-mm-role~="list-container"]'),
			template = element.find('[data-mm-role~=list-template]').detach(),
			loadInvitations = () => {
				element.showProgressMessage('Loading invitations, please wait...');
				listContainer.empty();
				subscriptionModel.listAccountinvitations()
				.then(result => {
					if (!result || !result.length) {
						element.showSection('empty');
					} else {
						result.forEach(item => {
							const newItem = template.clone();
							newItem.find('[data-mm-role="email"]').text(item);
							newItem.find('[data-mm-role="remove-invitation"]').click(() => {
								element.showProgressMessage('Removing invitation for ' + item + ', please wait...');
								subscriptionModel.removeAccountInvitation(item)
								.then(loadInvitations)
								.catch((reason) => element.showError(reason))
								.then(() => element.trigger('itemRemoved'));
							});
							newItem.appendTo(listContainer);
						});
						element.showSection('invitations');
					}
				})
				.catch((reason) => element.showError(reason))
				.then(() => element.trigger('listShown'));

			};
		element.addClass('hidden');
		element.on('show', loadInvitations);
	});
};
